import api from '@pray/shared/utils/api';

export const getAllTeamMembers = async ({
  artistId = null,
  offset = 0,
  limit = 0,
  sortColumn = '',
  sortDirection = 'asc',
  options = {},
} = {}) => {
  if (!artistId) throw Error('Artist ID is required');

  const params = {};

  if (offset) params.offset = offset;

  if (limit) params.limit = limit;

  if (sortColumn) {
    params.sort_column = sortColumn;
    params.sort_direction = sortDirection;
  }

  const url = `/web/studio/artists/${artistId}/team-members`;
  const response = await api.executeGetRequest(url, params, options);

  return response.data;
};
